import React from "react"
import { useParams } from "react-router-dom"

import { useTranslate } from "context/translateContext"
import Button from "shared/components/Button/Button"

import styles from "./PlansSwitch.module.css"

const PlansSwitch = () => {
  const { t: translate } = useTranslate()
  const params = useParams()

  const isYearly = params?.type === "yearly"
  return (
    <div className="flex-container f-j-center m-t-30">
      <div className={`${styles.tabWrapper} flex-container f-a-center`}>
        <div className={[!isYearly && styles.selected, styles.tab].join(" ")}>
          <Button
            variation="textLink"
            className={styles.tabBtn}
            to="/plans/monthly"
          >
            {translate("Monthly billing")}
          </Button>
        </div>
        <div className={[isYearly && styles.selected, styles.tab].join(" ")}>
          <Button
            variation="textLink"
            className={styles.tabBtn}
            to="/plans/yearly"
          >
            {translate("Annual billing")}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default PlansSwitch
